import type { GenieKnowledgeEntry } from '../types';

import { carpalTunnelSyndrome } from './neuropathic/carpal-tunnel-syndrome';
import { gbs } from './neuropathic/gbs';
import { cidp } from './neuropathic/cidp';
import { mmn } from './neuropathic/mmn';
import { polyneuropathy } from './neuropathic/polyneuropathy';
import { radiculopathy } from './neuropathic/radiculopathy';
import { ulnarNeuropathyElbow } from './neuropathic/ulnar-neuropathy-elbow';
import { peronealNeuropathy } from './neuropathic/peroneal-neuropathy';
import { smallFiberNeuropathy } from './neuropathic/small-fiber-neuropathy';
import { plexopathy } from './neuropathic/plexopathy';
import { mononeuropathy } from './neuropathic/mononeuropathy';
import { demyelinatingNeuropathy } from './patterns/demyelinating-neuropathy';
import { motorNeuronDisease } from './motor-neuron/als';
import { myopathy } from './myopathic/myopathy';
import { inflammatoryMyopathy } from './myopathic/inflammatory-myopathy';
import { myotonicDystrophy } from './myopathic/myotonic-dystrophy';
import { myastheniaGravis } from './nmj/myasthenia-gravis';
import { lambertEaton } from './nmj/lambert-eaton';

/** Todas las entradas registradas (id canónico) */
export const ALL_KNOWLEDGE_ENTRIES: GenieKnowledgeEntry[] = [
  carpalTunnelSyndrome,
  gbs,
  cidp,
  mmn,
  polyneuropathy,
  radiculopathy,
  ulnarNeuropathyElbow,
  peronealNeuropathy,
  smallFiberNeuropathy,
  plexopathy,
  mononeuropathy,
  demyelinatingNeuropathy,
  motorNeuronDisease,
  myopathy,
  inflammatoryMyopathy,
  myotonicDystrophy,
  myastheniaGravis,
  lambertEaton,
];

const byId = new Map<string, GenieKnowledgeEntry>();
const aliasToId = new Map<string, string>();

for (const entry of ALL_KNOWLEDGE_ENTRIES) {
  byId.set(entry.id, entry);
  for (const alias of entry.aliases ?? []) {
    aliasToId.set(alias, entry.id);
  }
}

export function getKnowledgeEntryById(id: string): GenieKnowledgeEntry | undefined {
  return byId.get(id) ?? byId.get(aliasToId.get(id) ?? '');
}

export function getKnowledgeEntryIds(): string[] {
  return ALL_KNOWLEDGE_ENTRIES.map(e => e.id);
}
